<template lang="pug">
  PrintablePanel
    PageHeader Split Twins
    .row.split-ids()
      .col
        Datatable(class="twins"
                    :columns="columns"
                    :entries= "entries"
                    tableKey="twinsTable"
                    :sortable="false"
                    :perPage="30"
                    :footer="false"
                    :header-style="{fontSize: '0.75rem'}")
            template(slot="header")
              
            template(slot-scope="props")
              tr(id="twins")
                div(class="checkboxes" )
                    input(class="align-center justify-center" type="checkbox" name="twinName" 
                    :value="props.entry.lastName+'||'+props.entry.firstName+' '+props.entry.middleName+'||'+props.entry.idNbr+'||'+props.entry.idStateCd+'||'+props.entry.idTypeCd+'||'+props.entry.birthDt+'||'+props.entry.postalCode"
                     v-model="checkedTwin" @change="clearCheckedTwinError")

                td.body-3 {{ props.entry.lastName }}
                td.body-3 {{ props.entry.firstName }}
                td.body-3 {{ props.entry.middleName }}
                td.body-3 {{ props.entry.idNbr }}
                td.body-3 {{ props.entry.idStateCd }}
                td.body-3 {{ props.entry.idTypeCd }}
                td.body-3 {{ props.entry.birthDt.slice(0, props.entry.birthDt.indexOf(" ")) }}
                td.body-3 {{ props.entry.postalCode }}
        tr(id="split-button" )
                td.body-3.buttons
                  button.btn.btn-primary(@click.prevent="splitTwins") Split Twins
                  FormError(v-if="checkedTwinError")
                    span(style="font-size: 0.75rem") {{ checkedTwinError }}       
</template>

<script>
import Datatable from '../components/Datatable'
import HelpPopover from '../components/HelpPopover'
import CustomCheckbox from '@/components/CustomCheckbox'
import CustomRadio from '@/components/CustomRadio'
import SplitByBioModal from '@/components/SplitByBioModal'
import Modal from '@/components/Modal'
import PageHeader from '@/components/PageHeader'
import Datepicker from '@/components/Datepicker'
import PrintablePanel from '@/components/PrintablePanel'
import axios from '@/lib/axios'
import router from '@/router'
import syncLogo from '@/assets/img/sync.svg'
import { format, parse, addDays } from 'date-fns/esm'
import { globalError, globalSuccess, idType, waitReport } from '@/lib/utils'
import { formItem, clearForm } from '@/lib/formstore'

export default {
  name: 'SplitTwins',
  data: function() {
    return {
      subjectSid: String,
      entries: [],
      columns: [
        'Twin to Split',
        'Last Name',
        'First Name',
        'Middle Name',
        'ID Number',
        'State Code',
        'ID Type',
        'Date Of Birth',
        'Postal Code',
      ],
      checkedTwin: [],
      checkedTwinError: '',
    }
  },
  methods: {
    async splitTwins() {
      if (this.checkedTwin.length > 0) {
        let previousBioKeysList = new String()
        let previousIdKeysList = new String()

        try {
          await axios().post('/api/person_summary/split_twins', {
            subjectSid: this.subjectSid,
            twins: this.computedTwins,
          })
          this.$router.push('/my_reports')
        } catch (err) {
          globalError(err)
        }
      } else {
        this.checkedTwinError = 'Please select at least one row to split by.'
      }
    },
    arrayOfIds: function() {
      var allEntries = JSON.stringify(this.entries)
      var arrayOfIds = JSON.parse(allEntries)
      arrayOfIds = arrayOfIds.map(
        e => e['idNbr'] + '||' + e['idStateCd'] + '||' + e['idTypeCd'],
      )
      var setOfIds = new Set(arrayOfIds)
      arrayOfIds = Array.from(setOfIds) // no reason to make duplicate DB calls
      return arrayOfIds
    },
    arrayOfBioKeys: function() {
      var allEntries = JSON.stringify(this.entries)
      var arrayOfBioKeys = JSON.parse(allEntries)
      arrayOfBioKeys = arrayOfBioKeys.map(
        e => e['lastName'] + '||' + e['birthDt'] + '||' + e['postalCode'],
      )
      var setOfBioKeys = new Set(arrayOfBioKeys)
      arrayOfBioKeys = Array.from(setOfBioKeys) // no reason to make duplicate DB calls
      return arrayOfBioKeys
    },
    clearCheckedTwinError() {
      this.checkedTwinError = ''
    },
  },
  async beforeRouteEnter(to, _from, next) {
    try {
      let resp = await axios().get('api/person_summary/split_twins', {
        params: { subject_sid: to.params.id },
      })
      next(vm => {
        ;(vm.entries = resp.data),
          (vm.subjectSid = to.params.id),
          (vm.headers = resp.data)
      })
    } catch (err) {
      globalError(err)
    }
  },
  computed: {
    computedTwins() {
      return this.checkedTwin.map(t => {
        let splitArr = t.toString().split('||')
        let dateTimeSplit = splitArr[5].toString().split(' ')

        let lastName = splitArr[0]
        // throw away first and middle name
        let idNbr = splitArr[2]
        let idStateCd = splitArr[3]
        let idTypeCd = splitArr[4]
        let birthDt = dateTimeSplit[0]
        let postalCode = splitArr[6]

        let bioKey = lastName + birthDt + postalCode
        let idKey = idNbr + idStateCd + idTypeCd

        return {
          lastName,
          idNbr,
          idStateCd,
          idTypeCd,
          birthDt,
          postalCode,
          bioKey,
          idKey,
        }
      })
    },
  },
  components: {
    Datatable,
    HelpPopover,
    CustomCheckbox,
    PageHeader,
    PrintablePanel,
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/bodies';
@import '../assets/styles/breakpoints';
.split-twinss {
  margin-top: 2rem;
  label {
    @extend .body-3;
  }
}

.spinning {
  animation: spin 3s linear;
}

.tfoot tr td {
  width: 100%;
}

.checkboxes label {
  display: inline-block;
}

.checkboxes input {
  margin: 0px 0px 0px 5px;
  vertical-align: middle;
  position: relative;
  vertical-align: middle;
  bottom: 1px;
}

#split-count {
  color: #7c3a74;
  cursor: pointer;
}

#split-count:hover {
  color: black;
  text-decoration: underline;
  cursor: pointer;
}
</style>
